import React from 'react';
type AvatarProps = {
  name: string;
  src?: string;
  color?: string;
  className?: string;
};

/** Photo when available, otherwise an initials badge in the product palette. */
export function Avatar({
  name,
  src,
  color = 'bg-coral',
  className = ''
}: AvatarProps) {
  if (src) {
    return <img src={src} alt={name} loading="lazy" className={`rounded-full object-cover ${className}`} data-id="element-21" data-mp="1zo8lkidivft" />;
  }
  const initials = name.replace(/[^A-Za-z ]/g, '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'AC';
  return <span aria-label={name} className={`flex items-center justify-center rounded-full font-display text-sm font-bold text-white ${color} ${className}`} data-id="element-22" data-mp="bwswppvs50z9">
      {initials}
    </span>;
}